// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos globales y reseteo básico */
:root {
    --primary-color: #007bff;
    --secondary-color: #6c757d;
    --success-color: #28a745;
    --danger-color: #dc3545;
    --warning-color: #ffc107;
    --info-color: #17a2b8;
    --light-color: #f8f9fa;
    --dark-color: #343a40;
    --text-color: #333;
    --bg-color: #f4f7f6;
    --border-color: #dee2e6;
    --header-footer-bg: #212529;
    --header-footer-text: #fff;
    --box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.6;
    color: var(--text-color);
    background-color: var(--bg-color);
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

#app-root {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* Contenedores y Layout */
.container {
    width: 90%;
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: var(--box-shadow);
}

.page {
    padding: 20px;
    flex: 1;
}

/* NUEVAS CLASES PARA EL LAYOUT DE TRES COLUMNAS DE CAJERO */
.cashier-main-grid {
    display: grid;
    grid-template-columns: 1fr 2fr 1.5fr; /* 3 columnas: Selección (más pequeña), Formulario (más grande), Carrito (mediana) */
    gap: 2rem; /* Espacio entre las columnas */
    margin-top: 2rem;
    align-items: flex-start; /* Alinea el contenido de las columnas a la parte superior */
}

.cashier-column {
    background-color: #ffffff;
    border-radius: 0.75rem; /* Slightly more rounded */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* More pronounced shadow for columns */
    padding: 1.5rem;
    min-height: 500px; /* Ensure columns have a minimum height */
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Prevent content from spilling out */
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
    color: var(--dark-color);
    margin-bottom: 15px;
    font-weight: 600;
}

h1 { font-size: 2.5em; }
h2 { font-size: 2em; }
h3 { font-size: 1.75em; }

/* Formularios */
.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: var(--dark-color);
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="number"],
input[type="date"],
input[type="time"],
select,
textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    font-size: 1em;
    color: var(--text-color);
    background-color: var(--light-color);
}

input[type="checkbox"] {
    margin-right: 8px;
}

/* NUEVA REGLA: Reducir el largo de los campos de filtro */
.cashier-filter-input-width {
    width: 50%; /* Reduce el ancho a la mitad */
    max-width: 250px; /* Opcional: Ancho máximo para que no se estire demasiado */
    display: inline-block; /* Permite que otros elementos se coloquen al lado si hay espacio */
}

/* Botones */
.btn {
    display: inline-block;
    padding: 10px 20px;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
    border: 1px solid transparent;
}

.btn-primary {
    background-color: var(--primary-color);
    color: #fff;
    border-color: var(--primary-color);
}
.btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
}

.btn-secondary {
    background-color: var(--secondary-color);
    color: #fff;
    border-color: var(--secondary-color);
}
.btn-secondary:hover {
    background-color: #545b62;
    border-color: #545b62;
}

.btn-success {
    background-color: var(--success-color);
    color: #fff;
    border-color: var(--success-color);
}
.btn-success:hover {
    background-color: #218838;
    border-color: #218838;
}

.btn-danger {
    background-color: var(--danger-color);
    color: #fff;
    border-color: var(--danger-color);
}
.btn-danger:hover {
    background-color: #c82333;
    border-color: #c82333;
}

.btn-warning {
    background-color: var(--warning-color);
    color: var(--dark-color);
    border-color: var(--warning-color);
}
.btn-warning:hover {
    background-color: #e0a800;
    border-color: #e0a800;
}

.btn-info {
    background-color: var(--info-color);
    color: #fff;
    border-color: var(--info-color);
}
.btn-info:hover {
    background-color: #138496;
    border-color: #138496;
}

.btn-block {
    width: 100%;
    margin-top: 10px;
}

/* Tablas */
.table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.table th,
.table td {
    padding: 12px 15px;
    border: 1px solid var(--border-color);
    text-align: left;
}

.table th {
    background-color: var(--primary-color);
    color: #fff;
    font-weight: bold;
}

.table tbody tr:nth-child(even) {
    background-color: var(--light-color);
}

.table tbody tr:hover {
    background-color: #e9ecef;
}

/* Mensajes de Notificación */
.notification {
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-weight: bold;
    text-align: center;
    color: #fff;
}

.notification.success {
    background-color: var(--success-color);
}

.notification.error {
    background-color: var(--danger-color);
}

.notification.info {
    background-color: var(--info-color);
}

/* Componentes específicos (ej. Header, Footer) */
.header {
    background-color: var(--header-footer-bg);
    color: var(--header-footer-text);
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--box-shadow);
}

.header h1 {
    color: var(--header-footer-text);
    margin: 0;
}

.header nav ul {
    list-style: none;
    display: flex;
}

.header nav ul li {
    margin-left: 20px;
}

.header nav ul li a {
    color: var(--header-footer-text);
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;
}

.header nav ul li a:hover {
    color: var(--primary-color);
}

.footer {
    background-color: var(--header-footer-bg);
    color: var(--header-footer-text);
    padding: 15px 20px;
    text-align: center;
    margin-top: auto; /* Empuja el footer al final de la página */
    box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.05);
}

/* Modales */
.whatsapp-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
}

.whatsapp-modal-overlay.show {
    opacity: 1;
    visibility: visible;
}

.whatsapp-modal-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    width: 90%;
    max-width: 450px;
    position: relative;
    transform: translateY(-20px);
    transition: transform 0.3s ease;
}

.whatsapp-modal-overlay.show .whatsapp-modal-content {
    transform: translateY(0);
}

.whatsapp-modal-close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.8em;
    cursor: pointer;
    color: var(--secondary-color);
    line-height: 1;
    transition: color 0.2s ease;
}

.whatsapp-modal-close-btn:hover {
    color: var(--danger-color);
}

.whatsapp-modal-content h3 {
    color: var(--primary-color);
    margin-bottom: 15px;
    font-size: 1.5em;
}

.whatsapp-modal-content p {
    margin-bottom: 15px;
    color: var(--text-color);
}

.whatsapp-modal-content input[type="text"] {
    margin-bottom: 20px;
    padding: 12px;
    border-radius: 6px;
    border: 1px solid var(--border-color);
    font-size: 1.1em;
}

.whatsapp-modal-summary {
    background-color: var(--light-color);
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
    max-height: 200px;
    overflow-y: auto;
    font-size: 0.9em;
    line-height: 1.5;
    color: #555;
}

.whatsapp-modal-summary p {
    margin-bottom: 5px;
}

.whatsapp-modal-summary ul {
    list-style: none;
    padding-left: 0;
}

.whatsapp-modal-summary ul li {
    margin-bottom: 3px;
    background-color: #f0f0f0;
    padding: 5px 8px;
    border-radius: 4px;
}

.whatsapp-modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* Específicos de taquilla */

/* Contenedor de las tarjetas de carreras */
.race-cards-container {
    display: flex;
    flex-wrap: wrap; /* Permite que las tarjetas se envuelvan a la siguiente línea */
    gap: 1rem; /* Espacio entre las tarjetas */
    justify-content: flex-start; /* Alinea las tarjetas al inicio */
    margin-bottom: 1.5rem; /* Adjusted margin */
    padding-right: 0.5rem; /* Add some padding for potential scrollbar */
    max-height: 400px; /* Limit height to enable scrolling if many cards */
    overflow-y: auto; /* Enable vertical scrolling */
}

/* Estilo para las tarjetas de carrera */
.race-card {
    background-color: #f0f4f8; /* Un color de fondo suave */
    border: 1px solid #cbd5e0; /* Borde sutil */
    border-radius: 0.5rem;
    padding: 0.75rem; /* Slightly reduced padding */
    width: 150px; /* ANCHO AJUSTADO para que quepan 3 */
    min-height: 120px; /* Minimum height to ensure space */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    text-align: center; /* Center text within the card */
    flex-shrink: 0; /* IMPORANTE: Evita que se encoja */
}

.race-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #e2e8f0;
}

/* Estilo para la tarjeta de carrera activa (seleccionada) */
.race-card.active {
    border-color: #2563eb; /* Tailwind blue-600 */
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.5); /* Blue shadow to highlight */
    background-color: #e6f0ff; /* Lighter background for the selected one */
}

.race-card h3 {
    font-size: 1rem; /* Slightly smaller font size */
    font-weight: bold;
    color: #2d3748;
    margin-bottom: 0.25rem;
    line-height: 1.2;
}

.race-card p {
    font-size: 0.75rem; /* Smaller font size */
    color: #4a5568;
    margin-bottom: 0.1rem;
}

.race-card p strong {
    color: #2d3748;
}

/* Estilos para el formulario de apuesta */
.ticket-form-section.hidden {
    display: none;
}

/* Estilos generales para modales y códigos de barras */
.barcode-display-svg {
    width: 100%;
    height: 60px; /* Adjust height as needed for display on page */
}

/* Estilos para el carrito de apuestas pendientes */
#contenedorApuestasPendientes {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 1rem; /* Slightly reduced padding */
    margin-top: 1.5rem; /* Adjusted margin */
    flex-grow: 1; /* Allow it to grow in column */
    display: flex;
    flex-direction: column;
}

#contenedorApuestasPendientes h4 {
    font-size: 1.1rem; /* Slightly smaller */
    color: #2d3748;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid #edf2f7; /* Thinner border */
    padding-bottom: 0.5rem;
}

#contenedorApuestasPendientes ul {
    list-style: none;
    padding: 0;
    margin: 0;
    flex-grow: 1; /* Allow list to take up available space */
    overflow-y: auto; /* Enable scrolling for long lists */
    max-height: 250px; /* Max height for scrollable area */
    margin-bottom: 1rem;
}

#contenedorApuestasPendientes li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0; /* Slightly reduced padding */
    border-bottom: 1px dashed #e2e8f0;
    font-size: 0.85rem; /* Slightly smaller font */
}

#contenedorApuestasPendientes li:last-child {
    border-bottom: none;
}

#contenedorApuestasPendientes .flex-col p {
    margin: 0;
    color: #4a5568;
    font-size: 0.8rem; /* Smaller font */
}

#contenedorApuestasPendientes .flex-col p strong {
    color: #1a202c;
}

#contenedorApuestasPendientes button[data-index] {
    background-color: #ef4444; /* Red for delete */
    color: white;
    border: none;
    border-radius: 0.25rem;
    padding: 0.3rem 0.6rem; /* Smaller padding */
    cursor: pointer;
    font-size: 0.75rem; /* Smaller font */
    transition: background-color 0.2s ease;
}

#contenedorApuestasPendientes button[data-index]:hover {
    background-color: #dc2626;
}

.cart-action-buttons {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 2px solid #edf2f7;
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem; /* Space between buttons */
    flex-shrink: 0; /* Prevent shrinking when content overflows */
}

#manejarImprimirBoletosBtn, #manejarLimpiarBoletosBtn {
    background-color: #4c51bf; /* Indigo/blue */
    color: white;
    padding: 0.6rem 1rem; /* Adjusted padding */
    border: none;
    border-radius: 0.375rem;
    font-size: 0.9rem; /* Slightly smaller font */
    cursor: pointer;
    transition: background-color 0.2s ease;
}

#manejarImprimirBoletosBtn:hover, #manejarLimpiarBoletosBtn:hover {
    background-color: #434190; /* Darker indigo/blue */
}

#checkout-button {
    background-color: #4CAF50; /* Green for checkout */
    color: white;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 0.5rem;
    font-size: 1.1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 100%;
}

#checkout-button:hover {
    background-color: #45a049;
}

#checkout-button:disabled {
    background-color: #a0aec0;
    cursor: not-allowed;
}
.receipt-buttons-container {
    margin-top: 20px;
    text-align: center;
}

#print-receipt-button, #send-whatsapp-button {
    background-color: #007bff;
    color: white;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
    border: none;
}

#print-receipt-button:hover, #send-whatsapp-button:hover {
    background-color: #0056b3;
}

/* Admin Specific */
.admin-dashboard-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.admin-card {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: var(--box-shadow);
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.admin-card:hover {
    transform: translateY(-5px);
}

.admin-card h3 {
    margin-bottom: 10px;
    color: var(--info-color);
}

/* Payout Page Specific */
.payout-scan-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
}

.payout-details {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    background-color: var(--light-color);
}

.payout-details .result-status {
    font-size: 1.2em;
    font-weight: bold;
    margin-top: 10px;
}

.result-winner { color: var(--success-color); }
.result-loser { color: var(--danger-color); }
.result-pending { color: var(--warning-color); }
.result-voided { color: var(--secondary-color); }


/* Estilos para las tarjetas de caballos (modernos) */
.horse-card-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); /* Responsive grid */
    gap: 1rem; /* Space between cards */
    padding: 0.5rem; /* Little padding around the grid */
}

.horse-card {
    background-color: #ffffff; /* Clean white background */
    border: 1px solid #e0e7ee; /* Subtle border color */
    border-radius: 0.75rem; /* More rounded corners */
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease; /* Smooth transitions for all properties */
    position: relative; /* For checkmark positioning */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); /* Softer, more modern shadow */
    min-height: 90px; /* Slightly taller for better content display */
    user-select: none; /* Prevent text selection on click */
}

.horse-card:hover {
    transform: translateY(-3px); /* Slight lift effect on hover */
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1); /* Enhanced shadow on hover */
    border-color: #a7d9f7; /* Lighter, more vibrant blue on hover */
}

.horse-card input[type="checkbox"] {
    /* Visually hidden but still accessible */
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    pointer-events: none;
}

/* Estilos para la tarjeta seleccionada - ¡Más notable! */
.horse-card.selected {
    background-color: #ffe0e0 !important; /* Un rojo claro, con !important */
    border-color: #dc3545 !important; /* Un rojo más oscuro para el borde, con !important */
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.5); /* Una sombra roja sutil */
}

.horse-card-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    color: #1f2937; /* Darker text for better contrast (from Tailwind gray-800) */
    line-height: 1.4;
}

.horse-card-label .horse-number {
    font-size: 1.5rem; /* Larger number */
    font-weight: 700; /* Bolder */
    color: #2563eb; /* Deep blue for number (from Tailwind blue-600) */
    margin-bottom: 0.25rem;
}

.horse-card-label .horse-name {
    font-size: 1rem; /* Slightly larger name */
    font-weight: 600;
    margin-top: 0.25rem;
    line-height: 1.2;
}

.horse-card-label .jockey-name {
    font-size: 0.8rem; /* Slightly larger jockey name */
    color: #6b7280; /* Medium gray for jockey name (from Tailwind gray-500) */
    margin-top: 0.1rem;
    font-style: italic; /* Italicize jockey name */
}

.horse-card .checkmark-icon {
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
    color: #10b981; /* Green checkmark (from Tailwind emerald-500) */
    font-size: 1.3rem; /* Slightly larger icon */
    display: none;
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2)); /* Small shadow for depth */
}

.horse-card.selected .checkmark-icon {
    display: block;
    animation: fadeIn 0.3s ease-out; /* Fade in animation for checkmark */
}

@keyframes fadeIn {
    from { opacity: 0; transform: scale(0.8); }
    to { opacity: 1; transform: scale(1); }
}

/* Responsive Adjustments */
@media (max-width: 1024px) { /* On smaller desktops/large tablets */
    .cashier-main-grid {
        grid-template-columns: 1fr 1.5fr; /* Change to 2 columns */
        gap: 1.5rem;
    }
    .cart-summary-column {
        grid-column: 1 / -1; /* Make cart span full width at the bottom */
        order: 3; /* Ensure it appears after the other two columns */
    }
}

@media (max-width: 768px) { /* On tablets/mobile */
    .cashier-main-grid {
        grid-template-columns: 1fr; /* Stack into a single column */
        gap: 1rem;
    }
    .race-cards-container {
        max-height: 300px; /* Adjust height for mobile */
    }
    #contenedorApuestasPendientes ul {
        max-height: 200px; /* Adjust height for mobile */
    }
}
/* NUEVA REGLA RESPONSIVE para los campos de filtro */
@media (max-width: 768px) {
    .cashier-filter-input-width {
        width: 100%; /* Ocupa todo el ancho en pantallas pequeñas */
        max-width: unset; /* Reinicia el ancho máximo */
    }
}
.horse-checkbox-label {
    /* Clases de Tailwind:
       flex items-center justify-between
       p-2 rounded-md border border-gray-300
       bg-white shadow-sm cursor-pointer
       hover:bg-gray-100 transition-all duration-200 ease-in-out
    */
    /* Estilos adicionales si Tailwind no es suficiente o para override */
    min-width: 120px; /* Asegura un ancho mínimo para cada checkbox */
}

.horse-checkbox-label.selected {
    background-color: #e0f2fe; /* Color de fondo azul claro para seleccionado (como race-card.active) */
    border-color: #2563eb; /* Borde azul más oscuro */
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5); /* Sombra azul para resaltar */
}

/* Opcional: Ajustes para el texto dentro del label si es necesario */
.horse-checkbox-label .horse-number {
    font-weight: bold;
    color: #1a202c; /* Color oscuro */
}

.horse-checkbox-label .horse-name {
    color: #4a5568; /* Color gris para el nombre */
}

.horse-checkbox-label .jockey-name {
    color: #718096; /* Color más claro para el jinete */
    font-size: 0.75rem; /* Ajuste si se desea un tamaño específico */
}

/* Remover cualquier estilo remanente de las antiguas horse-cards si las había en style.css */
/* Asegúrate de que las reglas de .horse-card, .horse-card.selected, .checkmark-icon, etc.
   no estén duplicadas o en conflicto con estas nuevas reglas, preferiblemente eliminando las antiguas. */

/* Ejemplo: Asegurarse de que el input checkbox se vea por defecto */
/* Si tu input[type="checkbox"] estaba 'opacity: 0' o 'display: none',
   podrías necesitar sobreescribirlo si quieres verlo al lado del texto.
   En este caso, lo estamos gestionando con clases de Tailwind que lo hacen visible. */
.form-checkbox {
    /* Tailwind ya lo maneja, pero si tienes problemas, revisa esto */
    display: inline-block; /* Asegura que el checkbox sea visible */
    /* ... otros estilos por defecto si es necesario */
}
`, "",{"version":3,"sources":["webpack://./public/style.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,2HAA2H;IAC3H,gBAAgB;IAChB,wBAAwB;IACxB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,oCAAoC,EAAE,oFAAoF;IAC1H,SAAS,EAAE,+BAA+B;IAC1C,gBAAgB;IAChB,uBAAuB,EAAE,4DAA4D;AACzF;;AAEA;IACI,yBAAyB;IACzB,sBAAsB,EAAE,0BAA0B;IAClD,0CAA0C,EAAE,uCAAuC;IACnF,eAAe;IACf,iBAAiB,EAAE,yCAAyC;IAC5D,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,sCAAsC;AAC5D;;AAEA,aAAa;AACb;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,KAAK,gBAAgB,EAAE;AACvB,KAAK,cAAc,EAAE;AACrB,KAAK,iBAAiB,EAAE;;AAExB,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;;;;;;;;IAQI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,0DAA0D;AAC1D;IACI,UAAU,EAAE,+BAA+B;IAC3C,gBAAgB,EAAE,2DAA2D;IAC7E,qBAAqB,EAAE,mEAAmE;AAC9F;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,+EAA+E;IAC/E,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,iCAAiC;AACrC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,iDAAiD;AACjD;IACI,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB,EAAE,2CAA2C;IAC7D,0CAA0C;AAC9C;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA,4BAA4B;;AAE5B,2CAA2C;AAC3C;IACI,aAAa;IACb,eAAe,EAAE,+DAA+D;IAChF,SAAS,EAAE,+BAA+B;IAC1C,2BAA2B,EAAE,kCAAkC;IAC/D,qBAAqB,EAAE,oBAAoB;IAC3C,qBAAqB,EAAE,6CAA6C;IACpE,iBAAiB,EAAE,mDAAmD;IACtE,gBAAgB,EAAE,8BAA8B;AACpD;;AAEA,wCAAwC;AACxC;IACI,yBAAyB,EAAE,4BAA4B;IACvD,yBAAyB,EAAE,gBAAgB;IAC3C,qBAAqB;IACrB,gBAAgB,EAAE,6BAA6B;IAC/C,YAAY,EAAE,qCAAqC;IACnD,iBAAiB,EAAE,mCAAmC;IACtD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,yCAAyC;IACzC,kBAAkB,EAAE,gCAAgC;IACpD,cAAc,EAAE,mCAAmC;AACvD;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA,4DAA4D;AAC5D;IACI,qBAAqB,EAAE,sBAAsB;IAC7C,4CAA4C,EAAE,6BAA6B;IAC3E,yBAAyB,EAAE,4CAA4C;AAC3E;;AAEA;IACI,eAAe,EAAE,+BAA+B;IAChD,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB,EAAE,sBAAsB;IAC1C,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;AACjB;;AAEA,uDAAuD;AACvD;IACI,WAAW;IACX,YAAY,EAAE,gDAAgD;AAClE;;AAEA,mDAAmD;AACnD;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa,EAAE,6BAA6B;IAC5C,kBAAkB,EAAE,oBAAoB;IACxC,YAAY,EAAE,+BAA+B;IAC7C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB,EAAE,qBAAqB;IACxC,cAAc;IACd,sBAAsB;IACtB,gCAAgC,EAAE,mBAAmB;IACrD,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,YAAY,EAAE,0CAA0C;IACxD,gBAAgB,EAAE,oCAAoC;IACtD,iBAAiB,EAAE,mCAAmC;IACtD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB,EAAE,6BAA6B;IAChD,iCAAiC;IACjC,kBAAkB,EAAE,0BAA0B;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB,EAAE,iBAAiB;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB,EAAE,mBAAmB;IAC9C,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,sBAAsB,EAAE,oBAAoB;IAC5C,eAAe;IACf,kBAAkB,EAAE,iBAAiB;IACrC,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,YAAY,EAAE,0BAA0B;IACxC,cAAc,EAAE,6CAA6C;AACjE;;AAEA;IACI,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,oBAAoB,EAAE,qBAAqB;IAC3C,YAAY;IACZ,uBAAuB;IACvB,iBAAiB,EAAE,0BAA0B;IAC7C,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;AACtD;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;IAClD,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,iBAAiB,2BAA2B,EAAE;AAC9C,gBAAgB,0BAA0B,EAAE;AAC5C,kBAAkB,2BAA2B,EAAE;AAC/C,iBAAiB,6BAA6B,EAAE;;;AAGhD,qDAAqD;AACrD;IACI,aAAa;IACb,4DAA4D,EAAE,oBAAoB;IAClF,SAAS,EAAE,wBAAwB;IACnC,eAAe,EAAE,mCAAmC;AACxD;;AAEA;IACI,yBAAyB,EAAE,2BAA2B;IACtD,yBAAyB,EAAE,wBAAwB;IACnD,sBAAsB,EAAE,yBAAyB;IACjD,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,yBAAyB,EAAE,0CAA0C;IACrE,kBAAkB,EAAE,8BAA8B;IAClD,0CAA0C,EAAE,+BAA+B;IAC3E,gBAAgB,EAAE,+CAA+C;IACjE,iBAAiB,EAAE,oCAAoC;AAC3D;;AAEA;IACI,2BAA2B,EAAE,gCAAgC;IAC7D,yCAAyC,EAAE,6BAA6B;IACxE,qBAAqB,EAAE,wCAAwC;AACnE;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,yDAAyD;AACzD;IACI,oCAAoC,EAAE,kCAAkC;IACxE,gCAAgC,EAAE,qDAAqD;IACvF,4CAA4C,EAAE,0BAA0B;AAC5E;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc,EAAE,6DAA6D;IAC7E,gBAAgB;AACpB;;AAEA;IACI,iBAAiB,EAAE,kBAAkB;IACrC,gBAAgB,EAAE,WAAW;IAC7B,cAAc,EAAE,kDAAkD;IAClE,sBAAsB;AAC1B;;AAEA;IACI,eAAe,EAAE,yBAAyB;IAC1C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB,EAAE,gCAAgC;IACnD,cAAc,EAAE,yDAAyD;IACzE,kBAAkB;IAClB,kBAAkB,EAAE,0BAA0B;AAClD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc,EAAE,gDAAgD;IAChE,iBAAiB,EAAE,yBAAyB;IAC5C,aAAa;IACb,8CAA8C,EAAE,2BAA2B;AAC/E;;AAEA;IACI,cAAc;IACd,+BAA+B,EAAE,oCAAoC;AACzE;;AAEA;IACI,OAAO,UAAU,EAAE,qBAAqB,EAAE;IAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,2BAA2B;AAC3B,6BAA6B,sCAAsC;IAC/D;QACI,gCAAgC,EAAE,wBAAwB;QAC1D,WAAW;IACf;IACA;QACI,mBAAmB,EAAE,4CAA4C;QACjE,QAAQ,EAAE,kDAAkD;IAChE;AACJ;;AAEA,4BAA4B,sBAAsB;IAC9C;QACI,0BAA0B,EAAE,+BAA+B;QAC3D,SAAS;IACb;IACA;QACI,iBAAiB,EAAE,6BAA6B;IACpD;IACA;QACI,iBAAiB,EAAE,6BAA6B;IACpD;AACJ;AACA,qDAAqD;AACrD;IACI;QACI,WAAW,EAAE,8CAA8C;QAC3D,gBAAgB,EAAE,6BAA6B;IACnD;AACJ;AACA;IACI;;;;;KAKC;IACD,qEAAqE;IACrE,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA;IACI,yBAAyB,EAAE,wEAAwE;IACnG,qBAAqB,EAAE,0BAA0B;IACjD,4CAA4C,EAAE,8BAA8B;AAChF;;AAEA,qEAAqE;AACrE;IACI,iBAAiB;IACjB,cAAc,EAAE,iBAAiB;AACrC;;AAEA;IACI,cAAc,EAAE,8BAA8B;AAClD;;AAEA;IACI,cAAc,EAAE,mCAAmC;IACnD,kBAAkB,EAAE,4CAA4C;AACpE;;AAEA,6FAA6F;AAC7F;yGACyG;;AAEzG,oEAAoE;AACpE;;sFAEsF;AACtF;IACI,iEAAiE;IACjE,qBAAqB,EAAE,wCAAwC;IAC/D,kDAAkD;AACtD","sourcesContent":["/* Estilos globales y reseteo básico */\n:root {\n    --primary-color: #007bff;\n    --secondary-color: #6c757d;\n    --success-color: #28a745;\n    --danger-color: #dc3545;\n    --warning-color: #ffc107;\n    --info-color: #17a2b8;\n    --light-color: #f8f9fa;\n    --dark-color: #343a40;\n    --text-color: #333;\n    --bg-color: #f4f7f6;\n    --border-color: #dee2e6;\n    --header-footer-bg: #212529;\n    --header-footer-text: #fff;\n    --box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n    line-height: 1.6;\n    color: var(--text-color);\n    background-color: var(--bg-color);\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n#app-root {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Contenedores y Layout */\n.container {\n    width: 90%;\n    max-width: 1200px;\n    margin: 20px auto;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: var(--box-shadow);\n}\n\n.page {\n    padding: 20px;\n    flex: 1;\n}\n\n/* NUEVAS CLASES PARA EL LAYOUT DE TRES COLUMNAS DE CAJERO */\n.cashier-main-grid {\n    display: grid;\n    grid-template-columns: 1fr 2fr 1.5fr; /* 3 columnas: Selección (más pequeña), Formulario (más grande), Carrito (mediana) */\n    gap: 2rem; /* Espacio entre las columnas */\n    margin-top: 2rem;\n    align-items: flex-start; /* Alinea el contenido de las columnas a la parte superior */\n}\n\n.cashier-column {\n    background-color: #ffffff;\n    border-radius: 0.75rem; /* Slightly more rounded */\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* More pronounced shadow for columns */\n    padding: 1.5rem;\n    min-height: 500px; /* Ensure columns have a minimum height */\n    display: flex;\n    flex-direction: column;\n    overflow: hidden; /* Prevent content from spilling out */\n}\n\n/* Headings */\nh1, h2, h3, h4, h5, h6 {\n    color: var(--dark-color);\n    margin-bottom: 15px;\n    font-weight: 600;\n}\n\nh1 { font-size: 2.5em; }\nh2 { font-size: 2em; }\nh3 { font-size: 1.75em; }\n\n/* Formularios */\n.form-group {\n    margin-bottom: 15px;\n}\n\nlabel {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: var(--dark-color);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"time\"],\nselect,\ntextarea {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid var(--border-color);\n    border-radius: 5px;\n    font-size: 1em;\n    color: var(--text-color);\n    background-color: var(--light-color);\n}\n\ninput[type=\"checkbox\"] {\n    margin-right: 8px;\n}\n\n/* NUEVA REGLA: Reducir el largo de los campos de filtro */\n.cashier-filter-input-width {\n    width: 50%; /* Reduce el ancho a la mitad */\n    max-width: 250px; /* Opcional: Ancho máximo para que no se estire demasiado */\n    display: inline-block; /* Permite que otros elementos se coloquen al lado si hay espacio */\n}\n\n/* Botones */\n.btn {\n    display: inline-block;\n    padding: 10px 20px;\n    font-size: 1em;\n    font-weight: bold;\n    text-align: center;\n    text-decoration: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n    border: 1px solid transparent;\n}\n\n.btn-primary {\n    background-color: var(--primary-color);\n    color: #fff;\n    border-color: var(--primary-color);\n}\n.btn-primary:hover {\n    background-color: #0056b3;\n    border-color: #0056b3;\n}\n\n.btn-secondary {\n    background-color: var(--secondary-color);\n    color: #fff;\n    border-color: var(--secondary-color);\n}\n.btn-secondary:hover {\n    background-color: #545b62;\n    border-color: #545b62;\n}\n\n.btn-success {\n    background-color: var(--success-color);\n    color: #fff;\n    border-color: var(--success-color);\n}\n.btn-success:hover {\n    background-color: #218838;\n    border-color: #218838;\n}\n\n.btn-danger {\n    background-color: var(--danger-color);\n    color: #fff;\n    border-color: var(--danger-color);\n}\n.btn-danger:hover {\n    background-color: #c82333;\n    border-color: #c82333;\n}\n\n.btn-warning {\n    background-color: var(--warning-color);\n    color: var(--dark-color);\n    border-color: var(--warning-color);\n}\n.btn-warning:hover {\n    background-color: #e0a800;\n    border-color: #e0a800;\n}\n\n.btn-info {\n    background-color: var(--info-color);\n    color: #fff;\n    border-color: var(--info-color);\n}\n.btn-info:hover {\n    background-color: #138496;\n    border-color: #138496;\n}\n\n.btn-block {\n    width: 100%;\n    margin-top: 10px;\n}\n\n/* Tablas */\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\n.table th,\n.table td {\n    padding: 12px 15px;\n    border: 1px solid var(--border-color);\n    text-align: left;\n}\n\n.table th {\n    background-color: var(--primary-color);\n    color: #fff;\n    font-weight: bold;\n}\n\n.table tbody tr:nth-child(even) {\n    background-color: var(--light-color);\n}\n\n.table tbody tr:hover {\n    background-color: #e9ecef;\n}\n\n/* Mensajes de Notificación */\n.notification {\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    font-weight: bold;\n    text-align: center;\n    color: #fff;\n}\n\n.notification.success {\n    background-color: var(--success-color);\n}\n\n.notification.error {\n    background-color: var(--danger-color);\n}\n\n.notification.info {\n    background-color: var(--info-color);\n}\n\n/* Componentes específicos (ej. Header, Footer) */\n.header {\n    background-color: var(--header-footer-bg);\n    color: var(--header-footer-text);\n    padding: 15px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: var(--box-shadow);\n}\n\n.header h1 {\n    color: var(--header-footer-text);\n    margin: 0;\n}\n\n.header nav ul {\n    list-style: none;\n    display: flex;\n}\n\n.header nav ul li {\n    margin-left: 20px;\n}\n\n.header nav ul li a {\n    color: var(--header-footer-text);\n    text-decoration: none;\n    font-weight: bold;\n    transition: color 0.3s ease;\n}\n\n.header nav ul li a:hover {\n    color: var(--primary-color);\n}\n\n.footer {\n    background-color: var(--header-footer-bg);\n    color: var(--header-footer-text);\n    padding: 15px 20px;\n    text-align: center;\n    margin-top: auto; /* Empuja el footer al final de la página */\n    box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.05);\n}\n\n/* Modales */\n.whatsapp-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.whatsapp-modal-overlay.show {\n    opacity: 1;\n    visibility: visible;\n}\n\n.whatsapp-modal-content {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n    width: 90%;\n    max-width: 450px;\n    position: relative;\n    transform: translateY(-20px);\n    transition: transform 0.3s ease;\n}\n\n.whatsapp-modal-overlay.show .whatsapp-modal-content {\n    transform: translateY(0);\n}\n\n.whatsapp-modal-close-btn {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 1.8em;\n    cursor: pointer;\n    color: var(--secondary-color);\n    line-height: 1;\n    transition: color 0.2s ease;\n}\n\n.whatsapp-modal-close-btn:hover {\n    color: var(--danger-color);\n}\n\n.whatsapp-modal-content h3 {\n    color: var(--primary-color);\n    margin-bottom: 15px;\n    font-size: 1.5em;\n}\n\n.whatsapp-modal-content p {\n    margin-bottom: 15px;\n    color: var(--text-color);\n}\n\n.whatsapp-modal-content input[type=\"text\"] {\n    margin-bottom: 20px;\n    padding: 12px;\n    border-radius: 6px;\n    border: 1px solid var(--border-color);\n    font-size: 1.1em;\n}\n\n.whatsapp-modal-summary {\n    background-color: var(--light-color);\n    padding: 15px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    border: 1px solid #e0e0e0;\n    max-height: 200px;\n    overflow-y: auto;\n    font-size: 0.9em;\n    line-height: 1.5;\n    color: #555;\n}\n\n.whatsapp-modal-summary p {\n    margin-bottom: 5px;\n}\n\n.whatsapp-modal-summary ul {\n    list-style: none;\n    padding-left: 0;\n}\n\n.whatsapp-modal-summary ul li {\n    margin-bottom: 3px;\n    background-color: #f0f0f0;\n    padding: 5px 8px;\n    border-radius: 4px;\n}\n\n.whatsapp-modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n/* Específicos de taquilla */\n\n/* Contenedor de las tarjetas de carreras */\n.race-cards-container {\n    display: flex;\n    flex-wrap: wrap; /* Permite que las tarjetas se envuelvan a la siguiente línea */\n    gap: 1rem; /* Espacio entre las tarjetas */\n    justify-content: flex-start; /* Alinea las tarjetas al inicio */\n    margin-bottom: 1.5rem; /* Adjusted margin */\n    padding-right: 0.5rem; /* Add some padding for potential scrollbar */\n    max-height: 400px; /* Limit height to enable scrolling if many cards */\n    overflow-y: auto; /* Enable vertical scrolling */\n}\n\n/* Estilo para las tarjetas de carrera */\n.race-card {\n    background-color: #f0f4f8; /* Un color de fondo suave */\n    border: 1px solid #cbd5e0; /* Borde sutil */\n    border-radius: 0.5rem;\n    padding: 0.75rem; /* Slightly reduced padding */\n    width: 150px; /* ANCHO AJUSTADO para que quepan 3 */\n    min-height: 120px; /* Minimum height to ensure space */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    text-align: center; /* Center text within the card */\n    flex-shrink: 0; /* IMPORANTE: Evita que se encoja */\n}\n\n.race-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    background-color: #e2e8f0;\n}\n\n/* Estilo para la tarjeta de carrera activa (seleccionada) */\n.race-card.active {\n    border-color: #2563eb; /* Tailwind blue-600 */\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.5); /* Blue shadow to highlight */\n    background-color: #e6f0ff; /* Lighter background for the selected one */\n}\n\n.race-card h3 {\n    font-size: 1rem; /* Slightly smaller font size */\n    font-weight: bold;\n    color: #2d3748;\n    margin-bottom: 0.25rem;\n    line-height: 1.2;\n}\n\n.race-card p {\n    font-size: 0.75rem; /* Smaller font size */\n    color: #4a5568;\n    margin-bottom: 0.1rem;\n}\n\n.race-card p strong {\n    color: #2d3748;\n}\n\n/* Estilos para el formulario de apuesta */\n.ticket-form-section.hidden {\n    display: none;\n}\n\n/* Estilos generales para modales y códigos de barras */\n.barcode-display-svg {\n    width: 100%;\n    height: 60px; /* Adjust height as needed for display on page */\n}\n\n/* Estilos para el carrito de apuestas pendientes */\n#contenedorApuestasPendientes {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    padding: 1rem; /* Slightly reduced padding */\n    margin-top: 1.5rem; /* Adjusted margin */\n    flex-grow: 1; /* Allow it to grow in column */\n    display: flex;\n    flex-direction: column;\n}\n\n#contenedorApuestasPendientes h4 {\n    font-size: 1.1rem; /* Slightly smaller */\n    color: #2d3748;\n    margin-bottom: 0.75rem;\n    border-bottom: 1px solid #edf2f7; /* Thinner border */\n    padding-bottom: 0.5rem;\n}\n\n#contenedorApuestasPendientes ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    flex-grow: 1; /* Allow list to take up available space */\n    overflow-y: auto; /* Enable scrolling for long lists */\n    max-height: 250px; /* Max height for scrollable area */\n    margin-bottom: 1rem;\n}\n\n#contenedorApuestasPendientes li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem 0; /* Slightly reduced padding */\n    border-bottom: 1px dashed #e2e8f0;\n    font-size: 0.85rem; /* Slightly smaller font */\n}\n\n#contenedorApuestasPendientes li:last-child {\n    border-bottom: none;\n}\n\n#contenedorApuestasPendientes .flex-col p {\n    margin: 0;\n    color: #4a5568;\n    font-size: 0.8rem; /* Smaller font */\n}\n\n#contenedorApuestasPendientes .flex-col p strong {\n    color: #1a202c;\n}\n\n#contenedorApuestasPendientes button[data-index] {\n    background-color: #ef4444; /* Red for delete */\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    padding: 0.3rem 0.6rem; /* Smaller padding */\n    cursor: pointer;\n    font-size: 0.75rem; /* Smaller font */\n    transition: background-color 0.2s ease;\n}\n\n#contenedorApuestasPendientes button[data-index]:hover {\n    background-color: #dc2626;\n}\n\n.cart-action-buttons {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 2px solid #edf2f7;\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem; /* Space between buttons */\n    flex-shrink: 0; /* Prevent shrinking when content overflows */\n}\n\n#manejarImprimirBoletosBtn, #manejarLimpiarBoletosBtn {\n    background-color: #4c51bf; /* Indigo/blue */\n    color: white;\n    padding: 0.6rem 1rem; /* Adjusted padding */\n    border: none;\n    border-radius: 0.375rem;\n    font-size: 0.9rem; /* Slightly smaller font */\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n#manejarImprimirBoletosBtn:hover, #manejarLimpiarBoletosBtn:hover {\n    background-color: #434190; /* Darker indigo/blue */\n}\n\n#checkout-button {\n    background-color: #4CAF50; /* Green for checkout */\n    color: white;\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: 0.5rem;\n    font-size: 1.1rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    width: 100%;\n}\n\n#checkout-button:hover {\n    background-color: #45a049;\n}\n\n#checkout-button:disabled {\n    background-color: #a0aec0;\n    cursor: not-allowed;\n}\n.receipt-buttons-container {\n    margin-top: 20px;\n    text-align: center;\n}\n\n#print-receipt-button, #send-whatsapp-button {\n    background-color: #007bff;\n    color: white;\n    padding: 10px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-right: 10px;\n    border: none;\n}\n\n#print-receipt-button:hover, #send-whatsapp-button:hover {\n    background-color: #0056b3;\n}\n\n/* Admin Specific */\n.admin-dashboard-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.admin-card {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: var(--box-shadow);\n    text-align: center;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n.admin-card:hover {\n    transform: translateY(-5px);\n}\n\n.admin-card h3 {\n    margin-bottom: 10px;\n    color: var(--info-color);\n}\n\n/* Payout Page Specific */\n.payout-scan-area {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.payout-details {\n    margin-top: 20px;\n    padding: 20px;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    background-color: var(--light-color);\n}\n\n.payout-details .result-status {\n    font-size: 1.2em;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.result-winner { color: var(--success-color); }\n.result-loser { color: var(--danger-color); }\n.result-pending { color: var(--warning-color); }\n.result-voided { color: var(--secondary-color); }\n\n\n/* Estilos para las tarjetas de caballos (modernos) */\n.horse-card-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); /* Responsive grid */\n    gap: 1rem; /* Space between cards */\n    padding: 0.5rem; /* Little padding around the grid */\n}\n\n.horse-card {\n    background-color: #ffffff; /* Clean white background */\n    border: 1px solid #e0e7ee; /* Subtle border color */\n    border-radius: 0.75rem; /* More rounded corners */\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease; /* Smooth transitions for all properties */\n    position: relative; /* For checkmark positioning */\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); /* Softer, more modern shadow */\n    min-height: 90px; /* Slightly taller for better content display */\n    user-select: none; /* Prevent text selection on click */\n}\n\n.horse-card:hover {\n    transform: translateY(-3px); /* Slight lift effect on hover */\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1); /* Enhanced shadow on hover */\n    border-color: #a7d9f7; /* Lighter, more vibrant blue on hover */\n}\n\n.horse-card input[type=\"checkbox\"] {\n    /* Visually hidden but still accessible */\n    position: absolute;\n    left: -9999px;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n/* Estilos para la tarjeta seleccionada - ¡Más notable! */\n.horse-card.selected {\n    background-color: #ffe0e0 !important; /* Un rojo claro, con !important */\n    border-color: #dc3545 !important; /* Un rojo más oscuro para el borde, con !important */\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.5); /* Una sombra roja sutil */\n}\n\n.horse-card-label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    color: #1f2937; /* Darker text for better contrast (from Tailwind gray-800) */\n    line-height: 1.4;\n}\n\n.horse-card-label .horse-number {\n    font-size: 1.5rem; /* Larger number */\n    font-weight: 700; /* Bolder */\n    color: #2563eb; /* Deep blue for number (from Tailwind blue-600) */\n    margin-bottom: 0.25rem;\n}\n\n.horse-card-label .horse-name {\n    font-size: 1rem; /* Slightly larger name */\n    font-weight: 600;\n    margin-top: 0.25rem;\n    line-height: 1.2;\n}\n\n.horse-card-label .jockey-name {\n    font-size: 0.8rem; /* Slightly larger jockey name */\n    color: #6b7280; /* Medium gray for jockey name (from Tailwind gray-500) */\n    margin-top: 0.1rem;\n    font-style: italic; /* Italicize jockey name */\n}\n\n.horse-card .checkmark-icon {\n    position: absolute;\n    top: 0.6rem;\n    right: 0.6rem;\n    color: #10b981; /* Green checkmark (from Tailwind emerald-500) */\n    font-size: 1.3rem; /* Slightly larger icon */\n    display: none;\n    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2)); /* Small shadow for depth */\n}\n\n.horse-card.selected .checkmark-icon {\n    display: block;\n    animation: fadeIn 0.3s ease-out; /* Fade in animation for checkmark */\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: scale(0.8); }\n    to { opacity: 1; transform: scale(1); }\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1024px) { /* On smaller desktops/large tablets */\n    .cashier-main-grid {\n        grid-template-columns: 1fr 1.5fr; /* Change to 2 columns */\n        gap: 1.5rem;\n    }\n    .cart-summary-column {\n        grid-column: 1 / -1; /* Make cart span full width at the bottom */\n        order: 3; /* Ensure it appears after the other two columns */\n    }\n}\n\n@media (max-width: 768px) { /* On tablets/mobile */\n    .cashier-main-grid {\n        grid-template-columns: 1fr; /* Stack into a single column */\n        gap: 1rem;\n    }\n    .race-cards-container {\n        max-height: 300px; /* Adjust height for mobile */\n    }\n    #contenedorApuestasPendientes ul {\n        max-height: 200px; /* Adjust height for mobile */\n    }\n}\n/* NUEVA REGLA RESPONSIVE para los campos de filtro */\n@media (max-width: 768px) {\n    .cashier-filter-input-width {\n        width: 100%; /* Ocupa todo el ancho en pantallas pequeñas */\n        max-width: unset; /* Reinicia el ancho máximo */\n    }\n}\n.horse-checkbox-label {\n    /* Clases de Tailwind:\n       flex items-center justify-between\n       p-2 rounded-md border border-gray-300\n       bg-white shadow-sm cursor-pointer\n       hover:bg-gray-100 transition-all duration-200 ease-in-out\n    */\n    /* Estilos adicionales si Tailwind no es suficiente o para override */\n    min-width: 120px; /* Asegura un ancho mínimo para cada checkbox */\n}\n\n.horse-checkbox-label.selected {\n    background-color: #e0f2fe; /* Color de fondo azul claro para seleccionado (como race-card.active) */\n    border-color: #2563eb; /* Borde azul más oscuro */\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.5); /* Sombra azul para resaltar */\n}\n\n/* Opcional: Ajustes para el texto dentro del label si es necesario */\n.horse-checkbox-label .horse-number {\n    font-weight: bold;\n    color: #1a202c; /* Color oscuro */\n}\n\n.horse-checkbox-label .horse-name {\n    color: #4a5568; /* Color gris para el nombre */\n}\n\n.horse-checkbox-label .jockey-name {\n    color: #718096; /* Color más claro para el jinete */\n    font-size: 0.75rem; /* Ajuste si se desea un tamaño específico */\n}\n\n/* Remover cualquier estilo remanente de las antiguas horse-cards si las había en style.css */\n/* Asegúrate de que las reglas de .horse-card, .horse-card.selected, .checkmark-icon, etc.\n   no estén duplicadas o en conflicto con estas nuevas reglas, preferiblemente eliminando las antiguas. */\n\n/* Ejemplo: Asegurarse de que el input checkbox se vea por defecto */\n/* Si tu input[type=\"checkbox\"] estaba 'opacity: 0' o 'display: none',\n   podrías necesitar sobreescribirlo si quieres verlo al lado del texto.\n   En este caso, lo estamos gestionando con clases de Tailwind que lo hacen visible. */\n.form-checkbox {\n    /* Tailwind ya lo maneja, pero si tienes problemas, revisa esto */\n    display: inline-block; /* Asegura que el checkbox sea visible */\n    /* ... otros estilos por defecto si es necesario */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
